import script from "./chart_coinlist_favorites.vue?vue&type=script&setup=true&lang=js"
export * from "./chart_coinlist_favorites.vue?vue&type=script&setup=true&lang=js"

import "./chart_coinlist_favorites.vue?vue&type=style&index=0&id=83792444&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83792444"]])

export default __exports__